import { PropsWithChildren } from "react";

interface NoTranslateProps {
  className?: string;
}

export default function NoTranslate({ children, className }: PropsWithChildren<NoTranslateProps>) {
  return (
    <span translate="no" className={["notranslate", className].filter(Boolean).join(" ")}>
      {children}
    </span>
  );
}
